document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.js-tabs');
  const tabsContent = document.querySelectorAll('.js-tabs-content');
  const tabsClose = document.querySelectorAll('.js-tabs-close');

  if (!tabs.length) return; // Stop als er geen tabs zijn

  function removeActiveTabs() {
    tabs.forEach(tab => tab.classList.remove('active'));
    tabsContent.forEach(content => content.classList.remove('active'));
  }

  function activatedTab(e) {
    const tab = e.currentTarget;
    const tabContentId = tab.getAttribute('for');

    // Remove start-active classes
    const startActive = document.querySelectorAll('.start-active');
    startActive.forEach(start => start.classList.remove('start-active'));

    if (tabContentId) {
      const tabContent = document.querySelector(`#${tabContentId}`);
      if (tabContent && !tabContent.classList.contains('active') && !tab.classList.contains('active')) {
        removeActiveTabs();
        tabContent.classList.add('active');
        tab.classList.add('active');
      }
    }
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', e => {
      e.preventDefault();
      activatedTab(e);
    });
  });

  if (tabsClose.length) {
    tabsClose.forEach(close => {
      close.addEventListener('click', e => {
        e.preventDefault();
        removeActiveTabs();
      });
    });
  }
});


// WEBPACK FOOTER //
// ./src/scripts/modules/tabs.js